/**
 * The report variant discriminator on its own (008). Kept apart from
 * `reportSections.ts` so eager code — the Redux store slice, services — can
 * narrow `reports.report_type` without pulling the whole section config
 * into the first-paint chunk; the config module re-exports these.
 */
export const REPORT_TYPES = ['full_report', 'findings_report'] as const

export type ReportType = (typeof REPORT_TYPES)[number]

export const isReportType = (value: unknown): value is ReportType =>
  typeof value === 'string' && (REPORT_TYPES as readonly string[]).includes(value)
